import React, { useContext } from 'react';

type TRoutineContext = {
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  startDate: string;
  setStartDate: (startDate: string) => void;
  endDate: string;
  setEndDate: (endDate: string) => void;
};

const routineContext = React.createContext<TRoutineContext>(
  null as unknown as TRoutineContext
);

export const RoutineContextProvider = routineContext.Provider;
export const RoutineContextConsumer = routineContext.Consumer;
export const useRoutineContext = () => {
  const context = useContext(routineContext);
  return context;
};
